function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1.1971 -.18765)",
  fill: "none",
  stroke: "#404040"
}, React.createElement("path", {
  className: "icon-tertiary",
  transform: "matrix(.39987 0 0 .39862 .13152 -.50123)",
  d: "m18.958 20.531 2.7856 14.319h-16.133l-2.1944-11.293z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 9.3333,
  strokeWidth: 1.5028
}), React.createElement("path", {
  transform: "matrix(.39429 0 0 .39862 .10021 -.50121)",
  d: "m11.623 10.02c0-4.1584 3.3768-7.5352 7.5352-7.5352 4.1684 0 7.5352 3.3768 7.5352 7.5352 0 4.1684-3.3668 7.5352-7.5352 7.5352-4.1584 0-7.5352-3.3668-7.5352-7.5352",
  strokeMiterlimit: 8,
  strokeWidth: 1.5134
}), React.createElement("g", {
  strokeWidth: 0.6
}, React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "m5.1891 3.0523c0-0.47531 0.48204-0.86274 1.0747-0.86274 0.59659 0 1.0747 0.38743 1.0747 0.86274 0 0.4793-0.47809 0.86274-1.0747 0.86274-0.59264 0-1.0747-0.38344-1.0747-0.86274",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "m7.9708 3.0523c0-0.47531 0.49783-0.86274 1.1063-0.86274 0.61242 0 1.1063 0.38743 1.1063 0.86274 0 0.4793-0.49388 0.86274-1.1063 0.86274-0.60847 0-1.1063-0.38344-1.1063-0.86274",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "m15.283 8.4811-3.8037 3.01v-6.02l1.9019 1.505z",
  strokeMiterlimit: 8
})), React.createElement("path", {
  d: "m3.2089 8.5259c0.1336-2.1841 1.9296-3.2509 1.9296-3.2509"
}), React.createElement("path", {
  d: "m8.746 12.112 1.3633-0.27266"
})));
var SvgDropPartner = function SvgDropPartner(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 14.386,
    height: 13.503,
    viewBox: "0 0 14.386 13.503",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDropPartner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Drop-partner.ae1610ab.svg";
export { ForwardRef as ReactComponent };